export { default } from './Socials';
